module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp3_9006.7a5d6ab6.png";